import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 16,
	viewBox: "0 0 8 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 3,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 3,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 7,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 7,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 11,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 11,
			width: 2,
			height: 2,
			rx: 1,
			fill: "#D9D9D9"
		})
	]
});
export default SvgDrag;
